import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import Spinner from "../../components/Reusable/Spinner";
import useGetHook from "../../customHooks/useGetHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const UpdateUserComponent = loadable(
  () => import("../../components/Merchant User/MerchantEditUser")
);
const MerchantEditUser = () => {
  const { id } = useParams();

  const { data: profile } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });



  const { data, isLoading } = useGetHook({
    queryKey: [`user-${id}`],
    url: `${APIS.USER}${id}/`,
    params: {},
  });

  const { data: roles } = useGetHook({
    queryKey: [`roles`],
    url: APIS.GROUP,
    params: {},
  });

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit User ({data?.profile?.full_name})
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <UpdateUserComponent data={data} roles={roles} profile={profile} />
      )}
    </>
  );
};

export default MerchantEditUser;
